<template>
	<!-- Navigation -->
	<nav
		id="navbarExample"
		class="navbar navbar-expand-lg fixed-top navbar-light"
		aria-label="Main navigation">
		<div class="container">
			<!-- Image Logo -->
			<InertiaLink class="navbar-brand" :href="'/'">
				<img
					:src="'/img/logo.webp'"
					class="brand-image img-circle me-2"
					alt="NCU Logo" />
				<div class="brand-text">
					<div class="ts-text">{{ $t("CAService", "zh-TW") }}</div>
					<div class="ts-text is-small">
						{{ $t("CAService", "en-US") }}
					</div>
				</div>
			</InertiaLink>

			<!-- Text Logo - Use this if you don't have a graphic logo -->

			<button
				class="navbar-toggler p-0 border-0"
				type="button"
				id="navbarSideCollapse"
				aria-label="Toggle navigation"
				data-bs-toggle="collapse"
				data-bs-target="#navbarsExampleDefault"
				aria-controls="navbarsExampleDefault"
				aria-expanded="false">
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse" id="navbarsExampleDefault">
				<ul class="navbar-nav ms-auto navbar-nav-scroll">
					<li class="nav-item">
						<!-- <a
                            class="nav-link active"
                            aria-current="page"
                            href="#header"
                            >Home</a
                        > -->
						<InertiaLink
							aria-current="page"
							href="/"
							class="nav-link"
							:class="{
								active: $page.url === '/',
							}">
							<span class="ts-icon is-house-chimney-icon"></span>
							{{ $t("home") }}
						</InertiaLink>
					</li>
					<li class="nav-item">
						<InertiaLink
							href="/download"
							class="nav-link"
							:class="{
								active: $page.url.startsWith('/download'),
							}">
							{{ $t("softwareDownload") }}
						</InertiaLink>
					</li>
					<li class="nav-item">
						<InertiaLink
							href="/docs"
							class="nav-link"
							:class="{
								active: $page.url.startsWith('/docs'),
							}">
							{{ $t("document") }}
						</InertiaLink>
					</li>
					<li class="nav-item">
						<a
							href="https://ncu.edu.tw/KMS/"
							:title="
								$t('newTab') +
								$t('goto') +
								' ' +
								$t('KMS') +
								' ' +
								$t('website')
							"
							target="_blank"
							class="nav-link">
							{{ $t("KMS") }}
						</a>
					</li>
					<li class="nav-item">
						<InertiaLink
							href="/softwareList"
							class="nav-link"
							:class="{
								active: $page.url === '/softwareList',
							}">
							{{ $t("softwareList") }}
						</InertiaLink>
					</li>
					<li class="nav-item">
						<InertiaLink
							href="/problemReport"
							class="nav-link"
							:class="{
								active: $page.url === '/problemReport',
							}">
							{{ $t("reportProblem") }}
						</InertiaLink>
					</li>
				</ul>

				<ul class="navbar-nav ms-3">
					<li class="nav-item">
						<a
							v-if="$i18n.locale == 'zh-TW'"
							class="nav-link"
							:href="'#'"
							@click="changeLang">
							<span class="ts-icon is-globe-icon"></span>
							EN
						</a>
						<a
							v-else
							class="nav-link"
							:href="'#'"
							@click="changeLang">
							<span class="ts-icon is-globe-icon"></span>
							中文
						</a>
					</li>
					<template v-if="!user">
						<li class="nav-item login">
							<InertiaLink
								href="/login"
								title="使用者登入"
								class="nav-link btn-solid-sm">
								<span>{{ $t("login") }}</span>
								<span
									class="ts-icon is-right-to-bracket-icon"
									style="line-height: 1"></span>
							</InertiaLink>
						</li>
					</template>
					<template v-else>
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle btn-solid-sm"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false">
								<span
									class="ts-icon is-user-icon"
									style="line-height: 1"></span>
								{{ " " + $page.props.auth?.user.account }}
							</a>
							<div
								class="dropdown-menu"
								aria-labelledby="navbarDropdown">
								<InertiaLink
									class="dropdown-item"
									href="/logs/login">
									<span class="ts-icon is-list-icon"></span>
									{{ $t("userLoginLog") }}
								</InertiaLink>
								<InertiaLink
									class="dropdown-item"
									href="/logs/download">
									<span
										class="
											ts-icon
											is-cloud-arrow-down-icon
										"></span>
									{{ $t("softDownloadLog") }}
								</InertiaLink>
								<InertiaLink
									class="dropdown-item"
									href="/about">
									<span
										class="
											ts-icon
											is-circle-info-icon
										"></span>
									{{ $t("aboutUs") }}
								</InertiaLink>
								<div class="dropdown-divider"></div>
								<a class="dropdown-item" href="/logout">
									<span
										class="
											ts-icon
											is-right-from-bracket-icon
										"></span>
									{{ $t("logout") }}
								</a>
							</div>
						</li>
					</template>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	name: "navbar",

	data() {
		return {};
	},
	methods: {
		changeLang() {
			if (this.$i18n.locale === "zh-TW") {
				this.$cookies.set("locale", "en-US");
				this.$i18n.locale = "en-US";
			} else {
				this.$cookies.set("locale", "zh-TW");
				this.$i18n.locale = "zh-TW";
			}
		},
	},
	computed: {
		user() {
			return this.$page.props.auth?.user;
		},
	},
	mounted() {
		if ($cookies.get("locale") == "en-US") {
			this.$i18n.locale = "en-US";
		}
	},
};
</script>

<style scoped>
.brand-text {
	justify-content: center;
	align-items: center;
	line-height: 1.5rem;
	size: 24px;
}

.brand-text:hover {
	text-decoration: none;
}

.brand-image {
	height: 2.73rem;
	width: auto;
}

.navbar-brand {
	display: inherit;
}
.login,
.logout {
	color: white;
}

.login:hover span,
.login i,
.logout:hover span,
.logout i {
	color: black;
}
</style>
